import { render, staticRenderFns } from "./TruncatedText.vue?vue&type=template&id=35d3f29f&"
import script from "./TruncatedText.vue?vue&type=script&lang=js&"
export * from "./TruncatedText.vue?vue&type=script&lang=js&"
import style0 from "./TruncatedText.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports